import { render, staticRenderFns } from "./Builder.vue?vue&type=template&id=1a064510&scoped=true"
import script from "./Builder.vue?vue&type=script&lang=ts"
export * from "./Builder.vue?vue&type=script&lang=ts"
import style0 from "./Builder.vue?vue&type=style&index=0&id=1a064510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a064510",
  null
  
)

export default component.exports